"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

import { Translation } from "@/data/lang";
import { links } from "@/data/links";
import { useLang } from "@/hooks/use-lang";
import { Lang } from "@/i18n-config";

const BlogLayout = ({
  children,
  params: { lang },
}: {
  children: React.ReactNode;
  params: { lang: Lang };
}) => {
  const { t } = useLang();
  const pathname = usePathname();
  const isBlogListPage = pathname.endsWith(links.myBlog);

  return (
    <section className="flex justify-center pb-10 @lg:px-4 @3xl:px-6 @7xl:px-36">
      <div className="flex w-full max-w-[var(--my-blog-width)] flex-col space-y-10">
        {isBlogListPage ? (
          <Title t={t} />
        ) : (
          <Link href={`/${lang}/${links.myBlog}`} className="w-fit">
            <Title t={t} />
          </Link>
        )}
        <div className="h-full">{children}</div>
      </div>
    </section>
  );
};

const Title = ({ t }: { t: Translation }) => (
  <h2 className="px-4 text-2xl font-bold text-white @lg:text-3xl @3xl:px-0">
    {t.blog.title}
  </h2>
);

export default BlogLayout;
